import "./about.css";

import React from "react";

import { ABOUT } from "../../data/content";
import PageBanner from "../general/PageBanner";
import PageMeta from "../general/PageMeta";
import SocialTiles from "../general/SocialTiles";

const About = () => {
  return (
    <React.Fragment>
      <PageMeta
        title={"About Us"}
        description={ABOUT.SUBTITLE}
      />
      <PageBanner
        title={ABOUT.TITLE}
        subtitle={ABOUT.SUBTITLE}
        color={"var(--teal)"}
        divider={"scallop"}
        dividerColor={"var(--teal)"}
      />
      <div
        className={"stripe-band"}
        style={{ "--band": "var(--teal)" }}
      />

      <section className={"about-story"}>
        <div className={"container"}>
          <div className={"about-story-text"}>
            <h2 className={"section-title"}>
              Family. Quality. <span className={"about-yellow"}>Care.</span>
            </h2>
            {ABOUT.STORY.map((paragraph) => (
              <p key={paragraph.slice(0, 24)}>{paragraph}</p>
            ))}
          </div>

          <div className={"about-bottom"}>
            <ul className={"about-stats"}>
              {ABOUT.STATS.map((stat) => (
                <li key={stat.label}>
                  <span className={"about-stat-value"}>{stat.value}</span>
                  <span className={"about-stat-label"}>{stat.label}</span>
                </li>
              ))}
            </ul>
            <SocialTiles className={"about-social"} />
          </div>
        </div>
      </section>
      <div
        className={"stripe-band"}
        style={{ "--band": "var(--teal)" }}
      />
    </React.Fragment>
  );
};

export default About;
